import { Injector } from '@angular/core';
import { fromEvent } from 'rxjs';
import {
  ShellConnector,
  shellConnectorToken,
} from '../../../../team-apis/core/shell-connector';
import { AbstractToolHelper } from './abstract-tool-helper';

export abstract class AbstractDragHandler extends AbstractToolHelper {
  protected shellConnector: ShellConnector;

  constructor(
    protected initialEvent: MouseEvent,
    injector: Injector,
  ) {
    super();
    // don't prevent default; that stops the output from gaining keyboard focus
    initialEvent.stopPropagation();
    this.shellConnector = injector.get(shellConnectorToken);
  }

  startListening() {
    this.subscribeTo(
      fromEvent<MouseEvent>(document, 'mousemove'),
      this.onMouseMove,
    );
    this.subscribeTo(fromEvent<MouseEvent>(document, 'mouseup'), (event) => {
      if (event.button === this.initialEvent.button) {
        event.stopPropagation();
        event.preventDefault();

        this.onMouseUp(event);
        void this.stopListening(event);
      }
    });
  }

  protected onMouseUp(_event: MouseEvent) {}

  protected abstract onMouseMove(event: MouseEvent): void;
}
